<template>
  <v-container
    class="pa-0"
    style="margin-top: 40px;"
  >
    <v-row
      no-gutters
    >
      <v-col
        cols="12"
      >
      <TimeLineWrapper
        v-if="schedule != null"
      >
        <TimeLineItem>
          <TimeLineDate
            v-if="ports != null"
            slot="slotDate"
            :timeVisible="false"
            :intervalDate="startLocation.pickup"
          />
          <TimeLineDate
            v-else
            slot="slotDate"
            :timeVisible="false"
            :visibleDate="startLocation.departure"
          />
          <TimeLineLocationCard
          slot='slotBody' slot-scope="{ handleExpand }"
          :handleExpandable="handleExpand"
          :companyName="startLocation.location.organization.name"
          :companyAddress="startLocation.location.address"
          :isExpandable="true"
          :isExpanded="false"
          :locationID="startLocation.location.id"
          >
              <LocationDetail
              slot='expandLocationCard'
              :organizationRef="startLocation.location.organization.organizationRef"
              :locationAddress="startLocation.location.address"
              :locationRef="startLocation.location.ref"
              :locationEquipment="startLocation.location.equipment"
              :locationAccessibility="startLocation.location.accessibility"
              :locationOpeningHours="startLocation.location.openingHours"
              :locationDate="startLocation.departure"
              :locationCoordinates="startLocation.location.coordinates"
              />
          </TimeLineLocationCard>
        </TimeLineItem>
        <template
          v-if="ports != null"
        >
            <TimeLineItem
              v-for="port in ports"
              :key="port.name"
            >
              <TimeLineLocationCard
              slot='slotBody'
              :companyName="port.location.organization.name"
              :companyAddress="port.location.address"
              :isExpandable="false"
              :isExpanded="false"
              >
              </TimeLineLocationCard>
            </TimeLineItem>
        </template>
        <TimeLineItem>
              <TimeLineDate
                v-if="ports != null"
                slot="slotDate"
                :timeVisible="false"
                :intervalDate="endLocation.delivery"
              />
              <TimeLineDate
                v-else
                slot="slotDate"
                :timeVisible="false"
                :visibleDate="endLocation.arrival"
              />
              <TimeLineLocationCard
              slot='slotBody'
              slot-scope="{ handleExpand }"
              :handleExpandable="handleExpand"
              :companyName="endLocation.location.organization.name"
              :companyAddress="endLocation.location.address"
              :isExpandable="true"
              :isExpanded="false"
              :locationID="endLocation.location.id"
              >
                  <LocationDetail
                  slot='expandLocationCard'
                  :organizationRef="endLocation.location.organization.ref"
                  :locationAddress="endLocation.location.address"
                  :locationRef="endLocation.location.ref"
                  :locationEquipment="endLocation.location.equipment"
                  :locationAccessibility="endLocation.location.accessibility"
                  :locationOpeningHours="endLocation.location.openingHours"
                  :locationDate="endLocation.arrival"
                  :locationCoordinates="endLocation.location.coordinates"
                  />
              </TimeLineLocationCard>
          </TimeLineItem>
        </TimeLineWrapper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TimeLineWrapper from '@/components/drops/location/TimeLineWrapper.vue'
  import TimeLineItem from '@/components/drops/location/TimeLineItem.vue'
  import TimeLineDate from '@/components/drops/location/TimeLineDate.vue'
  import TimeLineLocationCard from '@/components/drops/location/TimeLineLocationCard.vue'
  import LocationDetail from '@/components/drops/location/LocationDetail.vue'
  import TimeLineSubItem from '@/components/drops/location/TimeLineSubItem.vue'
  export default {
    name: 'ShipmentsGroupByDayContextSchedule',
    components: {
      TimeLineWrapper,
      TimeLineItem,
      TimeLineDate,
      TimeLineLocationCard,
      LocationDetail
    },
    props: {
      schedule: {type: Array, default: () => null},
      ports: { type: Array, default: () => null }
    },
    computed: {
      startLocation () {
        return this.schedule[0] != null ? this.schedule[0] : null
      },
      endLocation () {
        return this.schedule[this.schedule.length - 1] != null ? this.schedule[this.schedule.length - 1] : null
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
